export default __webpack_public_path__ + "static/project-slide-2-1248-765-564cdd44a4ef6e63bb1b8a12cbec37c8.webp";